<script lang="ts" setup>
import { useAutoHide } from './useAutoHide'

const { header, transform } = useAutoHide()
</script>
<template>
  <header ref="header" class="header" :style="{ transform: `translateY(${transform}px)` }">
    <nav class="container">
      <Logo />
      <Navigation class="desktop-only" />
      <HeaderActions />
    </nav>
  </header>
</template>
<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  background-color: white;

  z-index: 99;

  @include transitions(box-shadow);

  .is-scrolled & {
    box-shadow: var(--shadow-light-bottom);
  }

  nav {
    position: relative;
    height: var(--header-bar-height);

    display: flex;
    justify-content: space-between;
    gap: 30px;

    @include fluid(--button-action-width, 36px, 60px);
  }
}
</style>
